// getProfileTdk.js
'use strict';

import { ProfileListType } from '../resource/profileConstants.js';

/**
 * Get profile tdk
 * @param {string} username - username.
 * @param {string} biography - user's biography.
 * @param {string} listType - ex: ProfileListType.FLIX
 * @param {function} t - i18n.t
 */
const getProfileTdk = ({ username, biography, listType, t }) => {
  let displayTitle = t('seo_cp_title', {
    cp_name: username,
    cp_profile: biography,
    page_type: t('broadcast'),
  });
  let displayDescription = t('seo_cp_description', {
    cp_name: username,
    cp_profile: biography,
    page_type: t('broadcast'),
  });
  const displayKeywords = t('seo_cp_keywords', { cp_name: username });

  switch (listType) {
    case ProfileListType.FLIX: {
      displayTitle = t('seo_cp_profile_video_title', {
        cp_name: username,
        cp_profile: biography,
        page_type: t('title_flix'),
      });
      displayDescription = t('seo_cp_profile_video_description', {
        cp_name: username,
        cp_profile: biography,
        page_type: t('title_flix'),
      });
      break;
    }
    case ProfileListType.IMAGE: {
      displayTitle = t('seo_cp_profile_image_title', {
        cp_name: username,
        cp_profile: biography,
        page_type: t('profile_photo'),
      });
      displayDescription = t('seo_cp_profile_image_description', {
        cp_name: username,
        cp_profile: biography,
        page_type: t('profile_photo'),
      });
      break;
    }
    case ProfileListType.POST: {
      displayTitle = t('seo_cp_title', {
        cp_name: username,
        cp_profile: biography,
        page_type: t('post'),
      });
      displayDescription = t('seo_cp_description', {
        cp_name: username,
        cp_profile: biography,
        page_type: t('post'),
      });
      break;
    }
    case ProfileListType.STORY:
    default:
      break;
  }

  return { displayTitle, displayDescription, displayKeywords };
};

export default getProfileTdk;
